export default function Closing() {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
        >
          <source
            src="https://video.bailabailamove.com/kanpai_0204-3.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-black/50"></div>
      </div>
      
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full py-1 md:py-4">
        <div 
          className="text-lg md:text-4xl lg:text-5xl text-white font-bold tracking-tight leading-relaxed md:leading-relaxed"
          style={{ textShadow: '0 4px 30px rgba(0, 0, 0, 0.7), 0 2px 10px rgba(0, 0, 0, 0.5)' }}
        >
          <p className="mb-2 md:mb-16">
            <span className="font-bold">BAILA BAILA</span> <span className="font-light opacity-80">MOVE</span>は
          </p>
          <p className="mb-2 md:mb-16">
            「踊る人」ではなく
          </p>
          <p className="mb-2 md:mb-16">
            「表現する人」を増やすための
          </p>
          <p>
            プログラムです。
          </p>
        </div>
      </div>
    </section>
  );
}